import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4qzg2a3z5n: FaireBrandEntity = {
  token: "b_4qzg2a3z5n",
  type: "brand",
  name: "Freedom Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/95d46f5d97745ee5525880d91ed0be280ff1a19560cd5eab0d713548bea4873a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b61761e62d1da8560d7be04d3f9b8ab1545e5a53aac16cd13cbb0f3085e9b187.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95d46f5d97745ee5525880d91ed0be280ff1a19560cd5eab0d713548bea4873a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b61761e62d1da8560d7be04d3f9b8ab1545e5a53aac16cd13cbb0f3085e9b187.jpeg",
  location: "Sioux Falls, SD, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 155,
  isInsider: true,
  description:
    "Founded in 2020, Beth Gammel, Penny Klinedinst and Christin Majerus learned about the injustice of human trafficking and were determined to make a difference in their community. Together, they created Freedom Studios to hand craft beautiful bath and body products that raise awareness as well as create meaningful employment for survivors of human trafficking. \n\nFreedom Studios partnered with Call to Freedom, a non-profit organization who helps survivors by providing safe housing, counseling and treatment in South Dakota. \n\nSurvivors can heal in the most practical way, with an empowering job through Freedom Studios. This helps get them back on their feet financially and reintegrate into the workforce. Each product created in the studio is lovingly made by a survivor. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:26.422Z",
    importedBy: "entity-db-cli",
  },
};
